import React, {useEffect, useState} from 'react';
import OrderTags from "./OrderTags";
import { Button, debounce } from "@mui/material";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    UseCreateDineInReservation,
    UseCreateTakeOutReservation
} from "../../../api/useReservation";
import { GetUserCart, RemoveMealFromCart, UpdateMealQuantityInCart } from "../../../api/useMeal";
import { setUserValue } from "../../../reducers/userReducer";
import { useTranslation } from "react-i18next";

const updateMealQuantity = debounce(async (userId, mealId, quantity) => {
    try {
        if (userId && mealId && quantity > 0) {
            const result = await UpdateMealQuantityInCart(userId, mealId, quantity || 0);
            
            console.log("UpdateMealQuantityInCart result: ", result);
            
            if (result) {
            
            }
        }
    } catch (e) {
        console.error(e);
    }
}, 300);

const OrderTotalPrice = () => {
    const user = useSelector((state: any) => state.user);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {category, details, order} = useParams();
    const [foodCount, setFoodCount] = useState<number>(1);
    const [acceptedOrderData, setAcceptedOrderData] = useState<any>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [cartId, setCartId] = useState('');

    const scrollToTop = () => {
        window.scrollTo({ top: 122, behavior: 'smooth' });
    };

    useEffect(() => {
        const getCartData = async () => {
            try {
                if (user && user.id) {
                    setLoading(true);
                    const result = await GetUserCart(user.id);
                    
                    console.log("GetUserCart result: ", result);
                    
                    if (result && result.meals && result.meals.length > 0) {
                        dispatch(setUserValue({ key: "cartCount", value: result.meals.length }));
                        setAcceptedOrderData(result.meals);
                        setCartId(result._id);
                    } else {
                        dispatch(setUserValue({ key: "cartCount", value: 0 }));
                        setAcceptedOrderData([]);
                    }
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }
        
        getCartData().then(() => setLoading(false));
        
        scrollToTop();
    }, [user, isUpdate]);
    
    const handleQuantityChange = (mealId: string, newQuantity: number) => {
        setAcceptedOrderData((prevMeals: any) =>
          prevMeals.map((meal: any) =>
            meal.mealId === mealId ? { ...meal, quantity: newQuantity } : meal
          )
        );
        
        if (user && user.id) {
            updateMealQuantity(user.id, mealId, newQuantity);
        }
    };
    
    const handleDeleteOrder = async (mealId: string) => {
        try {
            if (user && user.id) {
                setLoading(true);
                const result = await RemoveMealFromCart(user.id, mealId);
                
                console.log("RemoveMealFromCart result: ", result);
                
                if (result) {
                    dispatch(setUserValue({ key: "cartCount", value: result.cart.meals.length }));
                    //setAcceptedOrderData(result.cart.meals);
                    setIsUpdate(!isUpdate);
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }
    
    const handleTakeOutReservation = async (item: any, time: string) => {
        try {
            if (user && user.id && cartId) {
                setLoading(true);
                const takeOutReservationObj = {
                    cartId: cartId,
                    reservationTime: time,
                    reservationName: user.name,
                    mealsNr: item.quantity,
                    takeOutAdId: item.mealId,
                    userId: user.id,
                }
                
                console.log("takeOutReservationObj: ", takeOutReservationObj);
                
                const result = await UseCreateTakeOutReservation(takeOutReservationObj);
                
                console.log("handleTakeOutReservation result: ", result);
                
                if (result && result.reservation && result.reservation._id) {
                    setIsUpdate(!isUpdate);
                    navigate(`/cart/${result.reservation._id}`);
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }
    
    const handleDineInReservation = async (item: any, time: string) => {
        try {
            if (user && user.id && cartId) {
                setLoading(true);
                console.log("item: ", item);
                const dineInReservationObj = {
                    cartId: cartId,
                    reservationTime: time,
                    reservationName: item.reserveName,
                    guestsNr: item.quantity,
                    dineInAdId: item.mealId,
                    userId: user.id,
                }
                
                console.log("dineInReservationObj: ", dineInReservationObj);
                
                const result: any = await UseCreateDineInReservation(dineInReservationObj);
                
                console.log("handleTakeOutReservation result: ", result);
                
                if (result && result.reservation && result.reservation._id) {
                    setIsUpdate(!isUpdate);
                    navigate(`/cart/${result.reservation._id}`);
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }
    
    return (
        <div className="orderTotalPrice__container">
            {
              acceptedOrderData && acceptedOrderData.length > 0 ? acceptedOrderData.map((item: any, index: number) => (
                <div className="orderTotalPrice__container-wrap" key={`${item.mealId} - ${item.mealData.data.updatedAt}`}>
                    <div className="orderTotalPrice__container-product-details-wrap">
                        <div className="orderTotalPrice__container-delete-product-wrap"
                          onClick={() => handleDeleteOrder(item.mealId)}
                        >
                            <div className="orderTotalPrice__container-delete-product-img">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/minus-delete-btn-icon.svg"}
                                    alt="delete icon"
                                />
                            </div>
                        </div>
                        <div className="orderTotalPrice__container-product-details">
                            <div className="orderTotalPrice__container-product-details-img">
                                {
                                    item?.mealData?.data?.image ? (
                                      <img
                                        src={item.mealData?.data.image}
                                        alt="product image"
                                      />
                                    ) : null
                                }
                            </div>
                            <div className="orderTotalPrice__container-product-details-info-wrap">
                                <div className="orderTotalPrice__container-product-details-main-info-wrap">
                                    <div className="orderTotalPrice__container-product-details-main-info-name">
                                        <span>{item?.mealData?.isDineIn ? item?.mealData?.data?.onOption : item?.mealData?.data?.name}</span>
                                    </div>
                                    {
                                        !item?.mealData?.isDineIn && (
                                        <div className="orderTotalPrice__container-product-details-main-info-count not-adaptive">
                                            <div
                                              className="orderTotalPrice__container-product-details-main-info-minus-count-btn"
                                              //onClick={() => handleMinusCount(index)}
                                              onClick={() => item.quantity > 1 && handleQuantityChange(item.mealId, item.quantity - 1)}
                                            >
                                                <img
                                                  src={`${process.env.PUBLIC_URL}/images/minus-count.svg`}
                                                  alt="minus count"
                                                />
                                            </div>
                                            <div className="orderTotalPrice__container-product-details-main-info-count-number">
                                                <span>{item.quantity}</span>
                                            </div>
                                            <div
                                              className="orderTotalPrice__container-product-details-main-info-plus-count-btn"
                                              //onClick={() => handlePlusCount(index)}
                                              onClick={() => {
                                                  if (item.quantity <= item?.mealData.data?.availableCount - 1) {
                                                      handleQuantityChange (item.mealId, item.quantity + 1)
                                                  }
                                              }}
                                            >
                                                <img
                                                  src={`${process.env.PUBLIC_URL}/images/plus-count.svg`}
                                                  alt="plus count"
                                                />
                                            </div>
                                        </div>
                                      )
                                    }
                                    {
                                        !item?.mealData?.isDineIn && (
                                        <div className="orderTotalPrice__container-product-details-main-info-price-wrap">
                                            <div className="orderTotalPrice__container-product-details-main-info-price">
                                                <span>€{item?.mealData?.data?.priceBefore}</span>
                                            </div>
                                            <div className="orderTotalPrice__container-product-details-main-info-discount">
                                                <span>€{item?.mealData?.data?.priceNow}</span>
                                            </div>
                                        </div>
                                      )
                                    }
                                </div>
                                
                                {
                                  !item?.mealData?.isDineIn && (
                                    <div className="orderTotalPrice__container-product-details-main-info-count adaptive">
                                        <div
                                          className="orderTotalPrice__container-product-details-main-info-minus-count-btn"
                                          //onClick={() => handleMinusCount(index)}
                                          onClick={() => item.quantity > 1 && handleQuantityChange(item.mealId, item.quantity - 1)}
                                        
                                        >
                                            <img
                                              src={`${process.env.PUBLIC_URL}/images/minus-count.svg`}
                                              alt="minus count"
                                            />
                                        </div>
                                        <div className="orderTotalPrice__container-product-details-main-info-count-number">
                                            <span>{item.quantity}</span>
                                        </div>
                                        <div
                                          className="orderTotalPrice__container-product-details-main-info-plus-count-btn"
                                          //onClick={() => handlePlusCount(index)}
                                          onClick={() => {
                                              if (item.quantity < item?.mealData.data?.availableCount) {
                                                  handleQuantityChange (item.mealId, item.quantity + 1)
                                              }
                                          }}
                                        >
                                            <img
                                              src={`${process.env.PUBLIC_URL}/images/plus-count.svg`}
                                              alt="plus count"
                                            />
                                        </div>
                                    </div>
                                  )
                                }

                                <div className="orderTotalPrice__container-product-details-time-info-wrap">
                                    <div className="orderTotalPrice__container-product-details-time-info">
                                        <div className="orderTotalPrice__container-product-details-time-info-title">
                                            <span>{t('buttons.pickUpAt')}:</span>
                                        </div>
                                        <div className="orderTotalPrice__container-product-details-time-info-time">
                                            <span>{item?.time}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="orderTotalPrice__container-product-details-category-info-wrap">
                                    <div className="orderTotalPrice__container-product-details-category-info">
                                        <span>
                                            {t(`categories.${item?.mealData?.category!.toLowerCase()}`)}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="orderTotalPrice__container-total-price-wrap">
                        <div className="orderTotalPrice__container-total-price-info-wrap">
                            <div className="orderTotalPrice__container-total-price-title-wrap">
                                <div className="orderTotalPrice__container-total-price-title-text">
                                    <span>{t('food.total')}</span>
                                </div>
                                {
                                    item?.mealData?.isDineIn ? (
                                      <div className="orderTotalPrice__container-total-price-title-price">
                                          <span>{item?.mealData?.data?.discount}% {t('const.discount')}</span>
                                      </div>
                                    ) : (
                                      <div className="orderTotalPrice__container-total-price-title-price">
                                          <span>€{((item?.price || 0) * (item?.quantity || 1)).toFixed(2)}</span>
                                      </div>
                                    )
                                }
                            </div>
                            <div className="orderTotalPrice__container-total-price-description-wrap">
                                <div className="orderTotalPrice__container-total-price-description-category">
                                    <span>{t(`categories.${item?.mealData?.category!.toLowerCase()}`)}</span>
                                </div>
                                <div className="orderTotalPrice__container-total-price-description-place">
                                    <span>{item?.mealData?.data?.address || ''}</span>
                                </div>
                            </div>
                        </div>

                        <div className="orderTotalPrice__container-total-price-btn-wrap">
                            <Button
                                className="orderTotalPrice__container-total-price-btn"
                                variant="contained"
                                onClick={() => item?.mealData?.isDineIn ? handleDineInReservation(item, item?.time) : handleTakeOutReservation(item, item?.time)}
                            >
                                <span>
                                    {item?.mealData?.isDineIn ? t('buttons.reserve') : t('buttons.pay')}
                                </span>
                            </Button>
                        </div>

                    </div>
                </div>
                ))
                :
                (
                  <div className="orderTotalPrice__container-empty-order-wrap">
                      <div className="orderTotalPrice__container-empty-order-text">
                          <span>{t('food.notHaveOrders')}</span>
                      </div>
                      <div className="orderTotalPrice__container-product-details-category-choose-food">
                          <NavLink to="/food">{t('food.seeMoreFood')}</NavLink>
                      </div>
                  </div>
                )
            }
            {/*{
              acceptedOrderData && acceptedOrderData.length > 0 && (
                    <div className="orderTotalPrice__container-tags-wrap">
                        <OrderTags tags={acceptedOrder.isDineIn ? acceptedOrder.category : acceptedOrder.data.tags} />
                    </div>
                )
            }*/}
        </div>
    );
};

export default OrderTotalPrice;